export const FRONT = 4;
export const RIGHT = 2;
export const BACK = 0;
export const LEFT = 6;
export const OrderedSteps = [FRONT,RIGHT,BACK,LEFT]